import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import { GetApp } from '@material-ui/icons'
import { Spacings } from '@styles'
import { paths } from '@routes'
import { strings } from '@constants'
import { FloatingButton, OutletWrapper, Search, Tabs } from '@base'
import { PONavigationWrapper, SpoNavigationWrapper } from './style'


// admin_manage_enquiry_spo_order_status
const SalesPurchaseOrder = () => {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const { pathname, search } = useLocation()
	const user = useSelector((_state) => _state.getIn(['user', 'user']))

	const urlParams = useParams()
	const orderStatus = urlParams?.orderStatus
	const spoId = urlParams?.spoId
	const hideTabs = !!orderStatus

	const searchWithoutPage = search
		.split('&')
		.filter((item) => !item.includes('page'))
		.join('&')

	useEffect(() => {
		// if (orderStatus && !['active', 'completed', 'cancelled'].includes(orderStatus)) {
		// 	navigate(paths.admin_manage_spo_status('all'))
		// }
	}, [orderStatus])

	// console.log('orderStatus', orderStatus, urlParams)

	const tabs = useMemo(() => {
		const tabs = [
			{
				label: strings('all'),
				href: search ? paths.admin_manage_spo_status('all') + searchWithoutPage : paths.admin_manage_spo_status('all'),
				selected: orderStatus === 'all',
			},
			{
				label: strings('active'),
				href: search ? paths.admin_manage_spo_status('active') + searchWithoutPage : paths.admin_manage_spo_status('active'),
				selected: orderStatus === 'active',
			},
			{
				label: strings('completed'),
				href: search ? paths.admin_manage_spo_status('completed') + searchWithoutPage : paths.admin_manage_spo_status('completed'),
				selected: orderStatus === 'completed',
			},
		]

		return tabs
	}, [orderStatus, pathname, search])

	return (
		<>
			{hideTabs && (
				<SpoNavigationWrapper>
					<Tabs data={tabs} />
					<PONavigationWrapper>
						<FloatingButton
							desktopLabel={strings('create', 'spo')}
							mobileLabel={<GetApp fontSize='small' />}
							small
							type='primary'
							margin={`0 ${Spacings.SPACING_1B} 0 0`}
							onClick={() => {
								navigate(paths.admin_create_spo)
							}}
						/>

						<Search clickHandler={() => {}} />
					</PONavigationWrapper>
				</SpoNavigationWrapper>
			)}
			<OutletWrapper>
				<Outlet />
			</OutletWrapper>
		</>
	)
}

export default SalesPurchaseOrder
